/** @jsx jsx */
import { css, keyframes } from '@emotion/core';
import { color } from "../../constants/styleConstants";

const loading = keyframes`
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(4);
    opacity: 0;
  }
`;

export const imageSliderStyle = {
  slideInner: css`
    padding: 4vw 4vw;
    width: 100%;
    height: 100%;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -6px -6px;
      width: 12px;
      height: 12px;
      background-color: ${color.gold};
      border-radius: 50%;
      animation: ${loading} 1.2s infinite;
      z-index: -1;
    }
  `,
  slideImg: css`
    object-fit: contain;
    position: static;
  `,
  zoomTarget: css`
    width: 100%;
    max-height: 100%;
    display: flex;
  `,
  nav: css`
    width: 3rem;
    height: 100%;
    position: absolute;
    top: 0;
    cursor: pointer;
    outline: none;
    z-index: 1;
    margin: 0;
    transition: opacity 0.5s ease;
    //opacity: 0;
    display: none;
    &:after {
        content: "";
        display: block;
        width: 2rem;
        height: 2rem;
        position: absolute;
        border: 1px solid #000;
        top: 50%;
    }
    &:hover {
        opacity: 0.5;
    }
  `,
  navPrev: css`
    width: 3rem;
    height: 100%;
    position: absolute;
    top: 0;
    cursor: pointer;
    outline: none;
    z-index: 1;
    margin: 0;
    transition: opacity 0.5s ease;
    left: 0;
    &:after {
      content: "";
      display: block;
      width: 2rem;
      height: 2rem;
      position: absolute;
      border: 1px solid #000;
      top: 50%;
      transform: translateY(-50%) rotate(-45deg);
      border-right: 0;
      border-bottom: 0;
      left: 1rem;
    }
  `,
  navNext: css`
    width: 3rem;
    height: 100%;
    position: absolute;
    top: 0;
    cursor: pointer;
    outline: none;
    z-index: 1;
    margin: 0;
    transition: opacity 0.5s ease;
    right: 0;
    &:after {
      content: "";
      display: block;
      width: 2rem;
      height: 2rem;
      position: absolute;
      border: 1px solid #000;
      top: 50%;
      transform: translateY(-50%) rotate(45deg);
      border-left: 0;
      border-bottom: 0;
      right: 1rem;
    }
  `,
}
